var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('Header'),_c('main',[_vm._m(0),_c('Items')],1)],1)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"shop"},[_c('i',{staticClass:"fas fa-shopping-cart"}),_c('h1',[_vm._v("Shop")])])
}]

export { render, staticRenderFns }